import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import VModal from 'vue-js-modal';
import VueMoment from 'vue-moment';
import VueQrcode from '@xkeshi/vue-qrcode';
import VueCookie from 'vue-cookie';
import VueYandexMetrika from 'vue-yandex-metrika';
import { fetchData } from './actions/identity';
import { types } from './types';
import setting from './config';

Vue.component(VueQrcode.name, VueQrcode);

// Vue.use(new VueSocketIO({
//   debug: true,
//   connection: setting.socketHost,
//   vuex: {
//     store,
//     actionPrefix: 'SOCKET_',
//     mutationPrefix: 'SOCKET_',
//   },
//   options: {}, //Optional options
// }));

const moment = require('moment');

Vue.config.productionTip = false;
Vue.use(VModal);
Vue.use(VueCookie);
Vue.use(VueMoment, {
  moment,
});

if (setting.yandexMetrikaId) {
  Vue.use(VueYandexMetrika, {
    id: setting.yandexMetrikaId,
    router: router,
    env: process.env.NODE_ENV,
  });
}

export const eventBus = new Vue();

new Vue({
  router,
  store,
  render: h => h(App),
  async created() {
    let paymentAttemptId = this.$route.query.paymentAttemptId;

    // paymentAttemptId = '5ecd48af-3340-7756-b09e-13c600146922';

    if (paymentAttemptId) {
      await this.$store.dispatch('getUserByPaymentId', {
        paymentAttemptId,
      });
    } else {
        let orderId = this.$route.query.orderId;
        if (orderId) {
          await this.$store.dispatch('getUserByPaymentId', {
            orderId,
          });
        }
    }

    const idToken = this.$cookie.get('i');

    console.log(document.referrer, window, 'document, window');

    //debugger;
    if (this.$route.params.session && this.$route.params.theatreId) {
      this.$store
        .dispatch('loadApp', {
          session: this.$route.params.session,
          theatreId: this.$route.params.theatreId,
          idToken,
        })
        .then(() => {
          // TODO в await контексте не сработает
          if (idToken && this.$route.params.theatreId) {
            fetchData(idToken).then(user => {
              //debugger;
              this.$store.commit(types.SET_USER_DATA, user);
              let cardNumber =
                user && user.profile && user.publicId
                  ? user.publicId
                  : 'карта отсутствует';
              this.$store.dispatch('logUser', {
                changes: `Получен пользователь ${user.profile.name} <br>Email: ${user.email}. <br>Номер карты: ${cardNumber}`,
                status: 'up',
              });

              if (cardNumber !== 'карта отсутствует') {
                this.$store.dispatch('fetchUserBalance', {
                  card: cardNumber,
                  apiKey: this.$route.params.theatreId,
                });
              }
            });
          }
        });

      // const user = {
      //   id: 'cjtfqm8fxosgk0735gu55blv1',
      //   username: 'devadmin',
      //   email: 'example@mediaten.ru',
      //   publicId: 714881722,
      //   status: 'ACTIVE',
      //   createdAt: '2019-03-19T12:11:45.597Z',
      //   updatedAt: '2019-12-26T08:19:50.500Z',
      //   role: ['ADMIN'],
      //   permissions: ['admin', 'crm'],
      //   crmSystems: [],
      //   profile: {
      //     id: 'cjtfqm8fzosgl073502d845lf',
      //     name: 'Administrator',
      //     image: 'https://cdn.pzpreprod.66bit.ru/img/76fmcohl5cy2f3bi.png',
      //     card: 714881722,
      //     birthday: '2005-09-22T00:00:00.000Z',
      //     gender: 'MALE',
      //     phone: '+7 111 111-11-11',
      //     mobilePhone: '+79028722480',
      //   },
      //   employeeInfo: {
      //     id: 'cjtfqm8g1osgn0735d29crvr9',
      //     phones: [],
      //     theatre: null,
      //   },
      // };
      // console.log(user, 'user');

      // this.$store.commit(types.SET_USER_DATA, user);
    } else {
      // Главная страница без контекста кинотеатра
      this.$store.commit(types.SET_LOADING, false);
      this.$router.push('/');
    }

    this.$moment.locale('Ru');
  },
}).$mount('#app');
